import React, { useEffect, useState } from 'react';
import './CitasPendientesMain.css'
import baseURL from '../../url';

export default function CitasPendientesData() {
    const [citas, setCitas] = useState([]);

    useEffect(() => {
        cargarCitas();
    }, []);

    const cargarCitas = () => {
        fetch(`${baseURL}/turnoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // Filtrar solo las citas pendientes y ordenar por fecha
                const citasPendientes = data.turnos
                    .filter(turno => turno.estado === "Pendiente")
                    .sort((a, b) => {
                        const fechaA = new Date(JSON.parse(a.dias)[0].dia);
                        const fechaB = new Date(JSON.parse(b.dias)[0].dia);
                        return fechaB - fechaA;
                    })
                    .slice(0, 5);
                setCitas(citasPendientes);
            })
            .catch(error => console.error('Error al cargar citas:', error));
    };

    return (
        <div className='table-containerUsuarios'>
            <div className='deFlexMore'>
                <h3>Últimas 5 citas pendientes</h3>
            </div>

            <div className="table-wrapper">
                <table className='table'>
                    <thead>
                        <tr>
                            <th>CESECO</th>
                            <th>Programa</th>
                            <th>Paciente</th>
                            <th>Fecha</th>
                            <th>Teléfono</th>
                        </tr>
                    </thead>
                    <tbody>
                        {citas.map(cita => {
                            const dias = JSON.parse(cita.dias);
                            return (
                                <tr key={cita.idTurno}>
                                    <td>{cita.nombreCategoria}</td>
                                    <td>{cita.servicio}</td>
                                    <td>{cita.nombre}</td>
                                    <td>{new Date(dias[0].dia).toLocaleDateString()} {dias[0].horaInicio}</td>
                                    <td>{cita.telefono}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
